// extracted by mini-css-extract-plugin
module.exports = {"priceUpdate":"_61e1603"};